/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Participant } from './participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
    ParticipantToJSONTyped,
} from './participant';

/**
 * 
 * @export
 * @interface WsParticipantNotified
 */
export interface WsParticipantNotified {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsParticipantNotified
     */
    type: string;
    /**
     * The conversation ID
     * @type {string}
     * @memberof WsParticipantNotified
     */
    conversationId: string;
    /**
     * The participant ID
     * @type {string}
     * @memberof WsParticipantNotified
     */
    participantId: string;
    /**
     * The notification channel (SMS or EMAIL)
     * @type {string}
     * @memberof WsParticipantNotified
     */
    notificationKind: string;
    /**
     * Whether the notification was sent successfully
     * @type {boolean}
     * @memberof WsParticipantNotified
     */
    success: boolean;
    /**
     * The reason for notification failure, if applicable
     * @type {string}
     * @memberof WsParticipantNotified
     */
    failureReason?: string | null;
    /**
     * The updated participant object with notification status
     * @type {Participant}
     * @memberof WsParticipantNotified
     */
    participant: Participant;
    /**
     * UUID sent by frontend to correlate API requests with websocket messages
     * @type {string}
     * @memberof WsParticipantNotified
     */
    correlationUuid?: string | null;
}

/**
 * Check if a given object implements the WsParticipantNotified interface.
 */
export function instanceOfWsParticipantNotified(value: object): value is WsParticipantNotified {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('notificationKind' in value) || value['notificationKind'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('participant' in value) || value['participant'] === undefined) return false;
    return true;
}

export function WsParticipantNotifiedFromJSON(json: any): WsParticipantNotified {
    return WsParticipantNotifiedFromJSONTyped(json, false);
}

export function WsParticipantNotifiedFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsParticipantNotified {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'conversationId': json['conversation_id'],
        'participantId': json['participant_id'],
        'notificationKind': json['notification_kind'],
        'success': json['success'],
        'failureReason': json['failure_reason'] == null ? undefined : json['failure_reason'],
        'participant': ParticipantFromJSON(json['participant']),
        'correlationUuid': json['correlation_uuid'] == null ? undefined : json['correlation_uuid'],
    };
}

export function WsParticipantNotifiedToJSON(json: any): WsParticipantNotified {
    return WsParticipantNotifiedToJSONTyped(json, false);
}

export function WsParticipantNotifiedToJSONTyped(value?: WsParticipantNotified | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'conversation_id': value['conversationId'],
        'participant_id': value['participantId'],
        'notification_kind': value['notificationKind'],
        'success': value['success'],
        'failure_reason': value['failureReason'],
        'participant': ParticipantToJSON(value['participant']),
        'correlation_uuid': value['correlationUuid'],
    };
}

